// extracted by mini-css-extract-plugin
export default {"shimmerText":"WithShimmerEffect-module__shimmerText--iLQCi","shimmer":"WithShimmerEffect-module__shimmer--yOKNr"};